import {DateTime} from "luxon";
import {injectable} from "tsyringe";
import {transformer} from "../decorators/transformer.decorator";
import {IssueTypeDTO} from "../domain/dtos/issue-type.dto";
import {IssueType} from "../domain/entities/issue-type.entity";
import {AbstractDtoToEntityTransformer} from "./abstract-dto-to-entity.transformer";

@injectable()
@transformer({
    source: `dto`,
    target: IssueType
})
export class DtoToIssueTypeTransformer extends AbstractDtoToEntityTransformer<IssueTypeDTO, IssueType> {

    protected toEntity(dto: IssueTypeDTO): Promise<IssueType> {
        return Promise.resolve(
            Object.assign(
                new IssueType(),
                {
                    include: dto.include,
                    shortcut: dto.shortcut,
                    cssClasses: dto.cssClasses,
                    showInHeader: dto.showInHeader,
                    description: dto.description,
                    isFixed: dto.isFixed,
                    color: dto.color,
                    parentUid: dto.parent ?? null,
                    isStatusless: dto.isStatusless ?? false,
                    isAbstract: dto.isAbstract ?? false,
                    canMoveRoot: dto.canMoveRoot ?? null,
                    canDelete: dto.canDelete ?? null,
                    deletedAt: !!dto.deletedAt ? DateTime.fromSQL(dto.deletedAt) : null,
                }
            )
        );
    }

}